export enum PanelPosition {
  Leading = "leading",
  Trailing = "trailing",
}

export enum PanelOrientation {
  Horizontal = "horizontal",
  Vertical = "vertical",
}
